<template>
  <div>
    <DialogBase
      title="Thêm đại lý"
      :visible.sync="isOpenAddBrandDialog"
      width="550px"
      panel-icon="el-icon-office-building"
      panel-title="ĐĂNG KÝ THÔNG TIN ĐẠI LÝ"
      panel-subtitle="Tạo mới một đại lý đại diện liên kết cổng thanh toán SePay cho nhà trường."
      :confirm-loading="loading.submit"
      confirm-text="Lưu lại"
      cancel-text="Hủy bỏ"
      @before-close="handleClose"
      @cancel="handleClose"
      @confirm="submitForm"
      @open="handleOpen"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="top"
        class="modern-form"
      >
        <el-form-item label="Trường liên kết đại lý" prop="idSchool">
          <el-select
            v-model="formData.idSchool"
            filterable
            placeholder="Chọn trường học..."
            class="full-width"
            @change="onSelectSchool"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tên đầy đủ đại lý" prop="full_name">
          <el-input
            v-model="formData.full_name"
            placeholder="Nhập tên đầy đủ..."
            maxlength="200"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="Tên viết tắt (mã nhận diện)" prop="short_name">
          <el-input
            v-model="formData.short_name"
            placeholder="Nhập tên viết tắt in hoa (A-Z, 0-9)..."
            maxlength="20"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="Trạng thái khởi tạo" prop="status">
          <el-select v-model="formData.status" placeholder="Chọn trạng thái" class="full-width" disabled>
            <el-option
              v-for="item in statusBrand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import { statusBrand } from "@/constant/listCommon";

export default {
  name: "AddBrandDialogVersion2",
  components: { DialogBase },
  props: {
    isOpenAddBrandDialog: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      statusBrand,
      formData: {
        full_name: "",
        idSchool: "",
        status: "Active",
        short_name: ""
      },
      schoolList: [],
      rules: {
        full_name: [
          {
            required: true,
            message: "Tên đầy đủ không được để trống!",
            trigger: "change"
          },
          { max: 200, message: "Tối đa 200 ký tự", trigger: "change" }
        ],
        short_name: [
          {
            required: true,
            message: "Tên viết tắt không được để trống",
            trigger: "change"
          },
          { max: 20, message: "Tối đa 20 ký tự", trigger: "change" },
          {
            pattern: /^[A-Z0-9]*$/,
            message: "Chỉ cho phép chữ cái in hoa (A-Z) và số",
            trigger: "change"
          }
        ],
        idSchool: [
          {
            required: true,
            message: "Trường không được để trống",
            trigger: "change"
          }
        ]
      },
      loading: {
        submit: false
      }
    };
  },

  methods: {
    onSelectSchool(schoolId) {
      const selectedSchool = this.schoolList.find((school) => school.id === schoolId);
      if (selectedSchool) {
        this.formData.full_name = selectedSchool.id + "-" + selectedSchool.schoolName;
        this.formData.short_name = "ONEKIDS" + selectedSchool.id;
      }
    },
    
    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      this.findAllAppIconForSchool();
    },
    
    async findAllAppIconForSchool() {
      try {
        const resp = await SystemConfigService.findSchoolConfig("", "", true);
        this.schoolList = resp.data.data || [];
      } catch (err) {
        console.error(err);
      }
    },
    
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          try {
            const resp = await sePayConnectionService.createCompanyV2(this.formData);
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Tạo mới thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Tạo mới thất bại!");
            }
            this.handleClose();
          } catch (err) {
            console.error(err);
            this.handleClose();
          } finally {
            this.loading.submit = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modern-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  /deep/ .el-input__inner {
    border-radius: 8px;
    height: 40px;
  }
}

.full-width {
  width: 100% !important;
  
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}
</style>